var link_viewer_default = {
  "fontElementMap": "lg1qX",
  "link": "duSU-",
  "linkInEditor": "NQDBz",
  "linkInViewer": "_89jf7",
  "toolbarUrlContainer": "mXvp4",
  "toolbarUrl": "FDCo7",
  "toolbarUrlAnchor": "YoLcy"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
